module.exports = __webpack_public_path__ + "static/storymap-c5c88c5b8cabc768030b2bab921c12c0.png";